import Engine from "../Engine/Engine";
import cfJS from "../Engine/cfJS";
import Controller from "../Engine/Controller";

class Picklist extends Controller {

    constructor(dom, options) {
        super(dom, "Picklist");

        let domNode = this.domNode = cfJS.byId(dom);

        this.inputDom = domNode.querySelector("input[type=text]");
        this.inputDomValue = domNode.querySelector("input[type=hidden]");
        this.tooltipDom = domNode.querySelector("cf-picklist-tooltip");
        this.picklistDomHelp = domNode.querySelector("cf-picklist-help");
        this.arrowDownDom = domNode.querySelector("cf-arrow-down");

        this.cacheSearchValue = "";

        this.isRequired = !!cfJS.attr(this.inputDomValue, "required");
        this.handlers = [];

        //default field color
        if (this.isRequired)
            cfJS.style(this.inputDom, "color", "#AAA");

        //show results
        cfJS.removeAttr(this.tooltipDom, "style");

        if (options["serverlistener"]) {
            this.disabledSend = false;
            this.serverlistener = options["serverlistener"];
        }

        //auto complete field value
        if (options["autocomplete"]) {
            this.autocomplete = true;
            cfJS.style(this.arrowDownDom, "display", "none");
            cfJS.style(this.inputDom, "color", "#000");
        }

        if (options["parent"]) {
            this._setParentEvents(options["parent"]);
        }

        cfJS.style(this.tooltipDom, "width", this.inputDom.offsetWidth + "px");

        if (options["value"]) {
            this._setDefaultValue(options["value"]);
        }

        this._connectHandlers();

        this._connectHandlersOptions();
    }

    /*
    *
    */
    _setParentEvents(param) {
        let that = this;

        function _callbackFromParent() {
            //clear value if changed parent value
            if (param["clearValueByChange"] && that.inputDomValue.value) {
                that._clearValue();
            }

            //auto set value
            if (param["singleAutoSet"]) {
                if (that.serverlistener) {
                    that._getServerOptions(() => {
                        let domChild = that.tooltipDom.querySelectorAll("cf-option");

                        if (domChild.length===1)
                            that._setValue(domChild[0]);
                    });
                }
            }
        }

        cfJS.getWidgetById(param["id"]).setCallback(_callbackFromParent);
    }
    /*
    * Set picklist-field default value
    * */
    _setDefaultValue(value) {
        let that = this;

        function _setValueFromOption(value) {
            that.inputDomValue.value = value;

            let cfOptions = that.domNode.querySelectorAll("cf-option");

            for (let i = 0; i < cfOptions.length; i++) {
                if (cfOptions[i].dataset.value === that.inputDomValue.value) {
                    that.inputDom.value = cfOptions[i].innerText;
                }
            }
        }

        if (!this.serverlistener) {
            _setValueFromOption(value);
        } else {
            this._getServerOptions(function () {
                _setValueFromOption(value);
            });
        }

    }

    _removeHandlersOptions() {
        for (let i in this.handlers) {
            this.handlers[i].disconnect();
        }
    }

    _connectHandlersOptions() {
        const that = this;
        let cfOptions = this.domNode.querySelectorAll("cf-option");

        for (let i = 0; i < cfOptions.length; i++) {
            this.handlers[this.handlers.length] = cfJS.addListener(cfOptions[i], "click", function (e) {
                that._setValue(cfOptions[i]);

                if (that.callbackOnChange)
                    that.callbackOnChange();
            });
        }
    }

    /*
    * Set other widget callback event
    */
    setCallback(callback) {
        this.callbackOnChange = callback;
    }

    /*
    * Set this dom element value
    */
    _setValue(dom) {
        let that = this;

        if (dom.dataset.cache)
            that.inputDom.value = dom.dataset.cache;
        else
            that.inputDom.value = dom.innerHTML;

        that.inputDomValue.value = dom.dataset.value;
        cfJS.removeAttr(that.tooltipDom, "show");

        that._checkValidation();
    }

    /*
    * Return tooltip actual status
    */
    isShowTooltip() {
        if (this.tooltipDom.hasAttribute("show"))
            return true;
        else
            return false;
    }

    /*
    * Function to search closes answers (samples)
    * */
    _showSearchResults(value) {
        if (this.cacheSearchValue===value)
            return;

        let cfOptions = this.domNode.querySelectorAll("cf-option"),
            isShow = false;

        this._removeMsgNotFound();

        for (let i = 0; i < cfOptions.length; i++) {
            cfJS.removeAttr(cfOptions[i], "hidden");
            cfJS.removeAttr(cfOptions[i], "disabled");

            if (cfJS.attr(cfOptions[i], "data-cache"))
                cfOptions[i].innerHTML = cfJS.attr(cfOptions[i], "data-cache");
        }

        if (value.length > 0) {
            for (let i = 0; i < cfOptions.length; i++) {
                if (cfOptions[i].dataset.value === this.inputDomValue.value) {
                    cfJS.attr(cfOptions[i], "disabled", "");
                }

                if (cfOptions[i].innerText.toLowerCase().indexOf(value.toLowerCase()) <= -1) {
                    cfJS.attr(cfOptions[i], "hidden", "");
                } else {
                    //set or get data from cache
                    if (!cfJS.attr(cfOptions[i], "data-cache"))
                        cfJS.attr(cfOptions[i], "data-cache", cfOptions[i].innerHTML);
                    else
                        cfOptions[i].innerHTML = cfJS.attr(cfOptions[i], "data-cache");

                    value = value.replace('+', '\\+');

                    cfOptions[i].innerHTML = "<span>" + (cfOptions[i].innerHTML.replace(new RegExp(value,'i'), function (match, p1, p2, p3, offset, string) {
                        let cfQ = document.createElement("cf-q");
                        cfQ.innerHTML = match;

                        return "</span><cf-q>" + cfQ.innerHTML + "</cf-q><span>";
                    })) + "</span>";

                    isShow = true;
                }
            }

            if (isShow) {
                cfJS.attr(this.tooltipDom, "show", "");
            } else {
                this._createMsgNotFound();
            }
        } else {
            if (cfOptions.length <= 0){
                this._createMsgNotFound();
            }
        }

        this.cacheSearchValue=value;
    }

    //Remove message dialog to "not found samples"
    _removeMsgNotFound() {
        let msgDom = this.tooltipDom.querySelector(".notFoundMsg");
        if (msgDom)
            this.tooltipDom.removeChild(msgDom);
    }

    //Create Not Found samples message
    _createMsgNotFound() {
        let msg = document.createElement("div");
        msg.classList.add("notFoundMsg");
        msg.innerHTML = this.tooltipDom.dataset.notfoundPhrase;
        this.tooltipDom.appendChild(msg);
    }

    /*
    * Opentooltip start function
    */
    _openTooltip() {
        const that = this;

        if (that.serverlistener)
            that._getServerOptions();

        that._showSearchResults(that.inputDom.value);

        cfJS.attr(that.tooltipDom, "show", "");
        cfJS.style(this.tooltipDom, "width", this.inputDom.offsetWidth + "px");
    }

    /*
    *
    */
    _getServerOptions(callback) {
        let that = this;

        if (that.disabledSend)
            return;

        let variables = engine.getPagesFieldsValue();
        variables["input.picklist.value"] = that.inputDom.value;
        that.disabledSend = true;
        that._removeMsgNotFound();

        engine.postRequest(this.serverlistener, variables, function (response) {
            try {
                var response = JSON.parse(response);
            } catch (e) {
                new Notice("500: Error request", "error");
                console.log(response);
                return;
            }

            response = response["result"];

            that.tooltipDom.innerHTML = "";
            that._removeHandlersOptions();

            for (var i in response) {
                var cfOptions = document.createElement("cf-option");
                cfJS.attr(cfOptions, "data-value", response[i]);
                cfOptions.innerHTML = i;
                that.tooltipDom.appendChild(cfOptions);
            }

            that._connectHandlersOptions();
            that._showSearchResults(that.inputDom.value);
            that.disabledSend = false;

            if (callback)
                callback();
        });
    }

    /*
    * Проверить валидацию поля, если есть параметр required
    */
    _checkValidation() {
        const that = this;

        if (that.isRequired) {
            if (!that.inputDomValue.value.length) {
                cfJS.attr(that.inputDom, "error", "");
                cfJS.style(this.inputDom, "color", "#BBB");
                cfJS.style(this.picklistDomHelp, "display", "block");
            } else {
                cfJS.removeAttr(that.inputDom, "error");
                cfJS.style(this.inputDom, "color", "#000");
                cfJS.style(this.picklistDomHelp, "display", "none");
            }
        }
    }
    /*
    *
    */
    _clearValue() {
        this.inputDom.value = "";

        //clear value
        this.inputDomValue.value = "";

        this._checkValidation();
    }
    /*
    * Подключить обработчики к dom - элементам
    */
    _connectHandlers() {
        const that = this;

        //Проверка на заполненость поля
        cfJS.addListener(that.inputDom, "change", function (e) {
            if (that.autocomplete)
                that.inputDomValue.value = that.inputDom.value;
            else {
                //clear value
                if (that.inputDomValue.value !== that.inputDom.value)
                    that.inputDomValue.value = "";
            }

            that._checkValidation();

            if (that.callbackOnChange)
                that.callbackOnChange();
        });

        cfJS.addListener(that.inputDom, "blur", function (e) {
            that._checkValidation();
        });

        cfJS.addListener(that.inputDom, "click", function (e) {
            cfJS.style(that.picklistDomHelp, "display", "none");

            if (that.serverlistener)
                that._getServerOptions();
        });

        cfJS.addListener(this.arrowDownDom, "click", function (e) {
            if (!that.isShowTooltip()) {
                that._openTooltip();
            } else {
                cfJS.removeAttr(that.tooltipDom, "show");
            }
        });

        cfJS.addListener(window, "click", function (e) {
            if (!that.isShowTooltip())
                return;

            let dom = e.target,
                clickInThisPicklist = false;
            while (dom && dom != document.body) {
                if (dom.id == that.domNode.id) {
                    clickInThisPicklist = true;
                    break;
                }

                dom = dom.parentNode;
            }

            if (!clickInThisPicklist)
                cfJS.removeAttr(that.tooltipDom, "show");
        });

        cfJS.addListener(window, "scroll", function (e) {
            if (!that.isShowTooltip())
                return;

            //hide showes result
            cfJS.removeAttr(that.tooltipDom, "show");
        });

        let timer = new Date();
        cfJS.addListener(this.inputDom, "keydown", function (e) {
            switch (e.key) {
                case "ArrowDown":
                    that._showSearchResults(that.inputDom.value);
                    cfJS.attr(that.tooltipDom, "show", "");
                    cfJS.style(this.tooltipDom, "width", this.inputDom.offsetWidth + "px");
                    return;
                    break;
                case "Enter":
                    let cfOptHidden = that.domNode.querySelector("cf-option:not([hidden])");

                    that._setValue(cfOptHidden);
                    break;
                default:
                    if (that.serverlistener)
                        that._getServerOptions();
                    break;
            }
        });

        cfJS.addListener(this.inputDom, "keyup", function (e) {
            that._showSearchResults(that.inputDom.value);
        });
    }
}

window.Picklist = Picklist;
